import { useCallback } from 'react';
import { useGetCatalogQuery } from '@platform/state/api';
import { routes } from '@platform/core/lib/routes';
import { useOpenInWorkspace } from '@platform/navigation/useOpenInWorkspace';
import type { IInboxEntry } from './IInboxEntry';

/**
 * Відкриття елемента вхідних (прототип v4): позначає прочитаним і відкриває запис у його робочому просторі (коментар — на вкладці
 * коментарів); модуль без конверта — за типом запису з каталогу. Елемент без запису лише позначається прочитаним.
 */
export function useOpenInboxEntry(ws: string, setRead: (entries: readonly IInboxEntry[], read: boolean) => void): (entry: IInboxEntry) => void {
  const open = useOpenInWorkspace();
  const { data: catalog } = useGetCatalogQuery({ workspaceId: ws }, { skip: !ws });
  return useCallback((entry: IInboxEntry) => {
    if (!entry.read) setRead([entry], true);
    const module = entry.module ?? catalog?.modules.find((m) => m.recordTypes.some((r) => r.key === entry.recordType))?.key;
    if (!entry.recordId || !entry.recordType || !module) return;
    open(entry.workspaceId, routes.record(module, entry.recordType, entry.recordId, entry.tab ?? undefined));
  }, [catalog, open, setRead]);
}
